import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const DASHBOARD_URL = '/dashboard';

/**
 * Keeps the exam flow (exam-loading → exam-recommendation → instructions →
 * question-paper → examination-submitted) out of the browser's back/forward
 * history. The flow pages replace each other (`replaceUrl`), so the page
 * before the flow — normally the dashboard or test series — is the furthest
 * back the student can go.
 *
 * - Browser back/forward onto a flow page never re-opens it: the stale entry
 *   is replaced with the dashboard, so "forward" from the dashboard can't
 *   restart a test.
 * - Leaving the app with "back" from a tab's first page is prevented by the
 *   history floor (`core/navigation/history-floor.ts`).
 */
export const examFlowHistoryGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (router.getCurrentNavigation()?.trigger === 'popstate') {
    // Redirects of browser-triggered navigations replace the history entry.
    return router.parseUrl(DASHBOARD_URL);
  }

  return true;
};
